import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {BaseServiceOrderVariant} from '../types';

const getServiceOrderVariantsResponseMock: BaseServiceOrderVariant[] = [
  {
    id: '0cf5155b-45ce-425e-af72-99524aed36b1',
    authorizationProfileId: '597601a2-ed1d-11ee-a951-0242ac120002',
    serviceCaseTypeId: 'bb252be9-569c-485b-b924-e76aecda7336',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Hyundai (Bratislava) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/COM',
    branchId: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
  },
  {
    id: '61d8cd9c-1da3-4eba-85cb-c39514c14e07',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '74dc1c4a-9622-4cc8-8641-725719e6bbaf',
    name: 'Hyundai (Praha) | Claims',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_INT',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/CLA',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '746b2976-77fa-4763-afc3-385675815a88',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Hyundai (Praha) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/COM',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '3a735d99-1269-40ed-b81c-2c8dd9e1566c',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Hyundai (Praha) Commercial - inspections',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: 'CI',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'e2964fd3-06d5-45a9-8cfe-eafacd404d27',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '3cbebbb9-9f19-4dd1-ac1e-4e4c55c50fa8',
    name: 'Hyundai (Praha) | Contract',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/CON',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'ddf85276-8d27-42ba-985a-d01caec5d831',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: 'e9a87a5d-eb41-402b-af63-2776c91ea059',
    name: 'Hyundai (Praha) | Insurance',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/INS',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '6588f228-7d26-4799-98e1-803cf2d2cf7e',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: 'bf147f23-ceb2-4fe3-9ef5-e076b6557615',
    name: 'Hyundai (Praha) | Internal',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_INT',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/INT',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '44c3bfa6-5cd3-41ab-b42b-4451f8c3aae0',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: 'c8e9d271-2a1c-47fd-b5fc-5aef54578cc6',
    name: 'Hyundai (Praha) | Warranty',
    priceType: 'WARRANTY_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_WAR',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/WAR',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'b877062f-ff11-4551-947b-9d08aef9fc05',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'MB Praha | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: 'CM',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '626ca8b8-c2fe-49ca-8016-5d0efb738d15',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: '74dc1c4a-9622-4cc8-8641-725719e6bbaf',
    name: 'Mercedes (Praha) | Claims',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_INT',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/CLA',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'af30bfa5-773c-4961-b1ed-9b9eabcd4d18',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Mercedes (Praha) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/COM',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '2fa5bf29-1c31-4b42-91c3-90d23e0533ad',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: '3cbebbb9-9f19-4dd1-ac1e-4e4c55c50fa8',
    name: 'Mercedes (Praha) | Contract',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/CON',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '57b2baa4-0919-4bfa-acef-15eab81cd13d',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: 'e9a87a5d-eb41-402b-af63-2776c91ea059',
    name: 'Mercedes (Praha) | Insurance',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/INS',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '9634c852-882a-4681-b783-b5d851ecdfd7',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: 'bf147f23-ceb2-4fe3-9ef5-e076b6557615',
    name: 'Mercedes (Praha) | Internal',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_INT',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    defaultCustomerId: '4b5a142d-e9ce-4089-8e64-efb4fc37cc69',
    isChangeableDefaultCustomer: false,
    suffix: '/INT',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'fdf29215-9c02-4c6f-88cd-0a463434e368',
    authorizationProfileId: '1ccb2695-cd20-4441-892e-08ee8a5af4e9',
    serviceCaseTypeId: 'c85475d6-2c5b-4a3d-956d-6ecc55b90f48',
    serviceOrderTypeId: 'c8e9d271-2a1c-47fd-b5fc-5aef54578cc6',
    name: 'Mercedes (Praha) | Warranty',
    priceType: 'WARRANTY_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_WAR',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    defaultCustomerId: 'c5dd0275-2599-42fb-bf9d-f657a30e1e32',
    isChangeableDefaultCustomer: false,
    suffix: '/WAR',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '739acf6a-bdf4-4e1f-9620-7ef6eef46c43',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'MPT Payment type tab',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '123123',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '795bd380-3b51-4ef4-b277-b67dde2d7a5d',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'My new SOV',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/MYSOV',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '7177b99b-5e5c-4633-a060-ff274f83591f',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'new',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: 'dasdasad',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '6d356cc6-a6e6-4bdf-b947-6fdd3fd1a1fd',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'New SOV',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/NEWSOV2',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'fb2b3ef8-014f-4267-b66a-693e91b9743e',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'NEXT',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/NEXT',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '29239506-2f31-44c9-aabe-6af8b6bb1f8e',
    authorizationProfileId: '5e8b9314-ed1d-11ee-a951-0242ac120002',
    serviceCaseTypeId: 'c9557a5f-3ae8-4638-9cca-c1cda844b382',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Other (Bratislava) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/COM',
    branchId: '29eaa1fc-3e1c-4a40-8b57-ec46e1bcdb22',
  },
  {
    id: '6e6a07c3-cc36-4c1b-b14b-abf9e45b9216',
    authorizationProfileId: 'ba4ec599-346d-4900-a9b5-85509bb6900f',
    serviceCaseTypeId: '2d2ae470-8b8b-4291-9b1c-3137b2a0e4d7',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Other (Praha) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/COM',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '26ce865c-f582-4473-90ab-93cd045b0932',
    authorizationProfileId: 'ba4ec599-346d-4900-a9b5-85509bb6900f',
    serviceCaseTypeId: '2d2ae470-8b8b-4291-9b1c-3137b2a0e4d7',
    serviceOrderTypeId: 'e9a87a5d-eb41-402b-af63-2776c91ea059',
    name: 'Other (Praha) | Insurance',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: 'INS',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: 'fbb9f304-2db3-495b-a6ee-d04b11f73640',
    authorizationProfileId: '88141214-fc4d-4459-8a1c-de076266391e',
    serviceCaseTypeId: '25f4c67c-8a39-4435-9067-56c4e5b011b0',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Other (Warsaw) | Commercial',
    priceType: 'SALES_BASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: true,
    suffix: '/COM',
    branchId: '4865e2a6-664a-467a-91f8-24d58d2d7c6e',
  },
  {
    id: '593d8037-d336-444c-845b-11aac6b12086',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'SOV 2',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/SOV2',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '4576d0f7-c9c2-48f0-97ad-f57c20bff1ec',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Third',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: '/3',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
  {
    id: '9e78197b-1fd9-4855-88df-928248efab47',
    authorizationProfileId: 'bab7f1dc-f7de-4c4f-a59a-76ebe05c23ea',
    serviceCaseTypeId: 'adb37f7c-616e-44f2-b915-e6cc951021b1',
    serviceOrderTypeId: '2918d816-47e1-4362-ae50-d157af0df411',
    name: 'Whatever',
    note: 'co ja vim',
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_COM',
    rateTypeRatio: 1,
    isUnitPriceWithVat: false,
    isChangeableDefaultCustomer: false,
    suffix: 'W/E',
    branchId: '659b8f3b-4923-4d2c-8938-a2e397a5c2c3',
  },
];

const getServiceOrderVariantsResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/service/v1/settings/service-order-variants', () =>
      HttpResponse.json(getServiceOrderVariantsResponseMock)
    )
  );

export const metadaWarehouseServiceOrderVariantApiMock = {
  getServiceOrderVariantsResponseMock,
  getServiceOrderVariantsResponseInterceptor,
};
